import React from "react";
import { Offcanvas, Button, ListGroup, Image } from "react-bootstrap";

import "./index.scss";
import { useCart } from "../../../context/CartContext";
import { CartIcon2 } from "../../../assets/icons/CartIcon2";
import { useNavigate } from "react-router-dom";

const CartDrawer = ({ show, handleClose }) => {
  const { cartItems, total, removeFromCart } = useCart();
  const navigate = useNavigate();
  return (
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>MON PANIER</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {cartItems.length === 0 ? (
          <p>Votre panier est vide</p>
        ) : (
          <>
            <ListGroup variant="flush">
              {cartItems.map((item) => (
                <ListGroup.Item
                  key={item._id}
                  className="d-flex align-items-center">
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={50}
                    height={50}
                    className="me-2 rounded"
                  />
                  <div className="flex-grow-1">
                    <p className="mb-0 fw-bold">{item.title}</p>
                    <small>
                      {item.quantity} x {item.price.toFixed(3)} dt
                    </small>
                  </div>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeFromCart(item._id)}>
                    ✕
                  </Button>
                </ListGroup.Item>
              ))}
            </ListGroup>

            {/* Résumé panier */}
            <div className="cart-summary1 mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <span>Total:</span>
                <strong>{total.toFixed(3)} dt</strong>
              </div>
            </div>

            <div className="d-grid gap-2 mt-3">
              <button className="btn-panier" onClick={handleClose}>
                <CartIcon2 /> PANIER
              </button>
              <button
                className="btn-checkout"
                onClick={() => {
                  navigate("/cart-page");
                  window.scrollTo(0, 0);
                  handleClose();
                }}>
                Procéder au paiement
              </button>
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CartDrawer;
